;(function() {
    const templateHelpers = {
        _dateFormat: new Intl.DateTimeFormat('en-AU', { year: 'numeric', month: 'long', day: 'numeric' }),

        formatTimestamp(timestamp) {
            const date = new Date(timestamp * 1000);

            return this._dateFormat.format(date);
        }
    };

    function debounce(fn, timeout = 100){
        let timer;

        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => { fn.apply(this, args); }, timeout);
        };
    }

    // Policy Library
    const $policyLibrarySearch = document.querySelectorAll('PolicyLibrarySearch');
    $policyLibrarySearch.forEach($search => {
        const $contentTypeFilter = $search.querySelector('.content-type-filter select');
        const $programAreaFilter = $search.querySelector('.program-area-filter select');
        const $yearFilter = $search.querySelector('.year-filter select');
        const $searchFilter = $search.querySelector('.search-filter input');
        const $resultsArea = $search.querySelector('#policy-library-results');        
        
        const templateStr = $search.querySelector('script[type="text/template"]').innerHTML;
        const templateFn = doT.template(templateStr).bind(templateHelpers);
        const template = new SearchTemplate({
            render(data) {
                const $template = document.createElement('template');
                $template.innerHTML = templateFn(data);
                return $template.content;
            }
        })
        
        const categoryFacet = new SearchFacet('categories', $contentTypeFilter, { placeholder: 'Policy Category' });
        const programAreaFacet = new SearchFacet('program_area', $programAreaFilter, { placeholder: 'Program Area' });
        const yearFacet = new SearchFacet('year', $yearFilter, { placeholder: 'Year' }); 

        const engine = new SearchEngine(
            'Q9E5TNU98N',
            '075e2b87a4ce13e4cf719037991c71f2',
            'staging_search',
            {
                postType: 'policy',
                template,
                results: $resultsArea,
                facets: [ categoryFacet, programAreaFacet, yearFacet ],
                pageSize: 100
            }
        );

        $searchFilter.addEventListener('keyup', debounce(async () => {
            engine.searchQuery = $searchFilter.value;
            await engine.update();
        }));
    });

    // Newsroom
    const $newsroomSearch = document.querySelectorAll('NewsroomSearch');
    $newsroomSearch.forEach($search => {
        const $programAreaFilter = $search.querySelector('.program-area-filter select');
        const $yearFilter = $search.querySelector('.year-filter select');
        const $resultsArea = $search.querySelector('#newsroom-results');        
        const $paginateLink = $search.querySelector('#newsroom-paginate');        
        
        const templateStr = $search.querySelector('script[type="text/template"]').innerHTML;
        const templateFn = doT.template(templateStr).bind(templateHelpers);
        const template = new SearchTemplate({
            render(data) {
                const $template = document.createElement('template');
                $template.innerHTML = templateFn(data);
                return $template.content;
            }
        })
        
        const programAreaFacet = new SearchFacet('program_area', $programAreaFilter, { placeholder: 'Program Area' });
        const yearFacet = new SearchFacet('year', $yearFilter, { placeholder: 'Year' }); 

        const engine = new SearchEngine(
            'Q9E5TNU98N',
            '075e2b87a4ce13e4cf719037991c71f2',
            'staging_search',
            {
                postType: 'post',
                template,
                results: $resultsArea,
                facets: [ programAreaFacet, yearFacet ],
                pageSize: 5
            }
        );

        engine.onQueryChange = () => {
            $paginateLink.style.display = 'block';
        }

        $paginateLink.addEventListener('click', async (e) => {
            e.preventDefault();

            const moreResults = await engine.loadMore();

            if(!moreResults) {
                $paginateLink.style.display = 'none';
            }

            return false;
        });
    });
})();